export default "__VITE_ASSET__8RjMHj4H__"